import React, { useState } from 'react';

import { OutlineButton } from '@riac/design-system';
import { ContentContainer } from '@riac/design-system';
import { Input } from '@riac/design-system';
import { InputError } from '@riac/design-system';
import { useFetch } from 'src/lib/FetchContext';
import { CustomerProductQuestionsArea, CustomerProductQuestionTextArea, DetailPagePublicQuestionContainer, DetailPagePublicQuestionList, DetailPageQuestionCancelButton } from 'src/pages/DetailPage/components/DetailPageQuestionArea.style';
import { LoginToUse } from 'src/components/LoginToUse/LoginToUse';

const DetailPagePublicQuestion = ({ question }) => {
  return (
    <DetailPagePublicQuestionContainer>
      <h3>Q</h3>
      <p>&nbsp;&nbsp;{question.Question}</p>
      <h3>A</h3>
      <p>&nbsp;&nbsp;{question.Answer}</p>
    </DetailPagePublicQuestionContainer>
  );
};

export const DetailPageQuestionArea = ({ itemInfo, allowAsk }) => {
  const [open, setOpen] = useState(false);
  const [question, setQuestion] = useState('');
  const { fetch } = useFetch();
  const customerQuestions = itemInfo?.CustomerQuestions;
  const [questionSubmitStatus, setQuestionSubmitStatus] = useState('idle');
  const submit = async () => {
    setQuestionSubmitStatus('running');
    try {
      const questionSubmitResponse = await fetch('/api/detail/question', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          questionText: question,
          auctionItemId: itemInfo.Items[0].AuctionItemID,
        }),
      });
      const questionSubmitResult = await questionSubmitResponse.json();
      if(questionSubmitResult.Success) {
        setQuestionSubmitStatus('success');
      } else {
        setQuestionSubmitStatus('error');
      }
    } catch (e) {
      console.error(e);
      setQuestionSubmitStatus('error');
    }
  };
  return (
    <CustomerProductQuestionsArea>
      <ContentContainer>
        <h2>Customer Product Questions</h2>
      </ContentContainer>
      <ContentContainer>
        {customerQuestions?.length === 0
          && <p>There are currently no customer product questions on this lot</p>
        }
        <DetailPagePublicQuestionList>
          {customerQuestions?.map((question) => (
            <DetailPagePublicQuestion question={question} key={question.Question + question.Answer}/>
          ))}
        </DetailPagePublicQuestionList>
      </ContentContainer>
      {allowAsk
        && <>
          <ContentContainer>
            {!open && (
              <LoginToUse
                overlayText = 'Log in to ask lot questions'
              >
                <OutlineButton onPress={() => {setOpen(true); setQuestion('');}}>
                  Ask a Question
                </OutlineButton>
              </LoginToUse>

            )
            || (
              <CustomerProductQuestionTextArea>
                <Input
                  label='Write Your Question Here'
                  id={`${itemInfo?.Items[0]?.AuctionItemID}_question`}
                  type='textarea'
                  name='question'
                  value={question || ''}
                  onChange={(e) => setQuestion(e)}
                  disabled={questionSubmitStatus === 'running' || questionSubmitStatus === 'success'}
                />
                <div>
                  <DetailPageQuestionCancelButton
                    onPress={() => {setOpen(false);}}
                    isDisabled={questionSubmitStatus === 'running'}
                  >
                    Close
                  </DetailPageQuestionCancelButton>
                  <OutlineButton
                    onPress={() => submit()}
                    isDisabled={questionSubmitStatus === 'running' || questionSubmitStatus === 'success'}
                  >
                    Submit Question
                  </OutlineButton>
                </div>
              </CustomerProductQuestionTextArea>
            )
            }
          </ContentContainer>
          <ContentContainer>
            {questionSubmitStatus === 'success'
              && <p>Your question has been submitted. It will appear in the sent tab of your account messages.</p>
            || ''}
            {questionSubmitStatus === 'error'
              && <InputError error='An error occurred submitting your question. Please contact directly at info@rockislandauction.com'/>
            || ''}
          </ContentContainer>
        </>
      }
    </CustomerProductQuestionsArea>
  );
};
